module.exports = __webpack_public_path__ + "static/media/raven-buy-sub.1330f1b0.svg";